export const truncateDecimals = (value: number, decimals = 2): number => {
  if (!Number.isFinite(value)) return value
  const factor = 10 ** decimals
  const scaled = value * factor
  const truncated = value < 0 ? Math.ceil(scaled) : Math.floor(scaled)
  
  return truncated / factor
}
